import React, { useEffect, useState } from 'react';
import { SALES_ORDER_COUNT_ENDPOINT } from '../../../config/api';

function SOCard({ userId, orgId }) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [orderCount, setOrderCount] = useState(null);

  // Fetch count initially
  useEffect(() => {
    if (!userId || !orgId) return;

    const fetchCount = async () => {
      try {
        const res = await fetch(SALES_ORDER_COUNT_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_id: userId, org_id: orgId })
        });
        const data = await res.json();
        if (res.ok && data.success) {
          setOrderCount(data.records?.length || 0);
        } else {
          setOrderCount(0);
        }
      } catch {
        setOrderCount(0);
      }
    };

    fetchCount();
  }, [userId, orgId]);

  const handleToggle = async () => {
    if (!showTable) {
      setLoading(true);
      try {
        const res = await fetch(SALES_ORDER_COUNT_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_id: userId, org_id: orgId })
        });
        const data = await res.json();
        if (res.ok && data.success && Array.isArray(data.records)) {
          setRecords(data.records);
        } else {
          setRecords([]);
        }
      } catch {
        setRecords([]);
      } finally {
        setLoading(false);
      }
    }
    setShowTable(prev => !prev);
  };

  return (
    <div className="card shadow border-0">
      <div className="card-body">
        <div
          className="d-flex justify-content-between align-items-center mb-2"
          style={{ cursor: 'pointer' }}
          onClick={handleToggle}
        >
          <h5 className="card-title mb-0">
            📦 Sales Orders {orderCount !== null && `(${orderCount})`}
          </h5>
          <span className="text-primary small">
            {showTable ? '▲ Hide' : '▼ Show'}
          </span>
        </div>

        {showTable && (
          <>
            {loading ? (
              <p className="text-center mb-0">Loading...</p>
            ) : records.length === 0 ? (
              <p className="text-center text-muted mb-0">No Sales Orders found.</p>
            ) : (
              <div className="table-responsive mt-3">
                <table className="table table-sm table-striped mb-0">
                  <thead>
                    <tr>
                      <th>Order ID</th>
                      <th>Customer</th>
                      <th>Material</th>
                      <th className="text-end">Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    {records.map((rec, idx) => (
                      <tr key={idx}>
                        <td>{rec.sales_order_id}</td>
                        <td>{rec.customer_name}</td>
                        <td>{rec.material_name}</td>
                        <td className="text-end">{rec.total_qty}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default SOCard;
